import React from 'react';

import { ArrowButton, Container } from './ProgressFooter.styled';
import ArrowDown from 'screens/IntakeForm/svg/arrow_down.svg?react';
import ArrowUp from 'screens/IntakeForm/svg/arrow_up.svg?react';

import ProgressBar from '../ProgressBar';

export const ProgressFooter = ({ percentComplete }: { percentComplete: number }) => {
  return (
    <Container>
      <ProgressBar progress={percentComplete} />
      <ArrowButton onClick={() => window.scrollTo(0, 0)}>
        <ArrowUp />
      </ArrowButton>
      <ArrowButton onClick={() => window.scrollTo(0, document.body.scrollHeight)}>
        <ArrowDown />
      </ArrowButton>
    </Container>
  );
};
